export default {"src":"/_next/static/media/searching_top_banner.639843c5.svg","height":57,"width":852,"blurWidth":0,"blurHeight":0};